import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 83 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#00B388",
      fillRule: "evenodd",
      d: "M11.84.042c2.481 0 4.676.204 6.012.515 2.663.564 4.76 2.682 5.318 5.37.308 1.35.51 3.567.51 6.073s-.202 4.724-.51 6.072c-.559 2.69-2.655 4.807-5.318 5.371-1.336.312-3.53.515-6.012.515s-4.677-.203-6.013-.515c-2.662-.564-4.759-2.682-5.318-5.37C.201 16.722 0 14.506 0 12s.201-4.723.51-6.072c.558-2.69 2.655-4.807 5.317-5.371C7.163.246 9.358.042 11.84.042m1.563 17.29c.58.122 1.057.529 1.282 1.07.07.168.227.289.41.272l.181-.017c.927-.093 1.656-.224 2.08-.375l.002-.002a.76.76 0 0 0 .487-.734l-.002-.04-.001-.01-.002-.024c-.072-.976-.659-3.261-1.535-5.869-1.002-2.981-2.05-5.395-2.523-5.866a1 1 0 0 0-.4-.259l-.005-.001c-.31-.106-.882-.177-1.538-.177-.655 0-1.227.07-1.537.177l-.005.001a1 1 0 0 0-.4.259c-.473.47-1.52 2.885-2.523 5.866-.876 2.608-1.463 4.893-1.535 5.869l-.002.025v.009l-.003.04v.024c0 .325.202.602.487.71l.002.002c.424.151 1.154.282 2.082.375l.167.016c.19.017.353-.109.427-.283a1.8 1.8 0 0 1 1.277-1.059c.348-.08.918-.133 1.564-.133.645 0 1.216.052 1.563.133",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M37.822 8.01h2.262v9.972h-2.263V16.23c-.707 1.243-1.919 1.956-3.495 1.956-2.626 0-4.727-2.323-4.727-5.196s2.1-5.175 4.727-5.175c1.576 0 2.788.713 3.496 1.956zm33.877 0h2.263v9.972h-2.263V16.23c-.707 1.243-1.92 1.956-3.495 1.956-2.627 0-4.728-2.323-4.728-5.196s2.101-5.175 4.728-5.175c1.575 0 2.788.713 3.495 1.956zm-36.837 8.01c1.717 0 3.01-1.304 3.01-3.036 0-1.712-1.293-3.016-3.01-3.016a3 3 0 0 0-3.01 3.016c0 1.69 1.333 3.036 3.01 3.036m33.759 0c1.717 0 3.01-1.304 3.01-3.036 0-1.712-1.293-3.016-3.01-3.016a3 3 0 0 0-3.01 3.016c0 1.69 1.333 3.036 3.01 3.036M43.472 3.032c.788 0 1.455.672 1.455 1.446 0 .815-.667 1.467-1.455 1.467s-1.434-.652-1.434-1.467c0-.774.646-1.446 1.434-1.446m-1.111 4.951h2.243v9.973H42.36zm9.287-.196c.432 0 .848.065 1.148.18.176.067.332.142.453.205l-.913 1.927a3.1 3.1 0 0 0-.91-.132c-1.091 0-2.303.917-2.303 2.67v5.318H46.88V7.982h2.242v1.435c.445-.958 1.556-1.63 2.526-1.63m11.263 7.641c-.748 1.65-2.485 2.73-4.546 2.73-2.93 0-5.172-2.22-5.172-5.175s2.223-5.196 5.152-5.196c1.92 0 3.536.958 4.263 2.425l-1.9 1.08c-.403-.795-1.292-1.325-2.363-1.325-1.697 0-2.93 1.304-2.93 3.016 0 1.691 1.253 2.995 2.95 2.995 1.152 0 2.101-.55 2.546-1.467zm15.57-12.396v14.923h-2.243V3.032zm4.519 0v14.923h-2.243V3.032z",
      clipRule: "evenodd"
    }
  )
);
var SvgAircallLogoFull = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AircallLogoFull_default = SvgAircallLogoFull;

export { AircallLogoFull_default as default };
